// extracted by mini-css-extract-plugin
export default {"inputFields":"hveLtbsUZhhq2Jc2ZMkZ4","startDate":"_3t7EwA0haeVOkLR7aMOzRn","icon":"_7zYWI8rq1IBuNCzm86AJ2q","priority":"_6BzmmxAkidefGBeLVuQlF8"};